<!--
 * @Descripttion: 地网2.0功能引导
 * @Author: chenjinsheng
 * @Date: 2021-10-14 11:13:44
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-15 15:15:28
-->
<template>
    <div class="guidance-container">
        <div class="bg1">
            <img src="@/assets/pics/guidance/bg1.png" alt="" />
        </div>
        <div class="bg2">
            <img src="@/assets/pics/guidance/bg2.png" alt="" />
        </div>
        <div class="bg3">
            <img src="@/assets/pics/guidance/bg3.png" alt="" />
        </div>
        <div class="bg4">
            <img src="@/assets/pics/guidance/bg4.png" alt="" />
        </div>
        <div class="bg5">
            <img src="@/assets/pics/guidance/bg5.png" alt="" />
        </div>
        <div class="bg6">
            <img src="@/assets/pics/guidance/bg6.png" alt="" />
        </div>
        <div class="bg7">
            <img src="@/assets/pics/guidance/bg7.png" alt="" />
        </div>
        <div class="bg8">
            <img src="@/assets/pics/guidance/bg8.png" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: "Guidance",
};
</script>

<style lang="scss" scoped>
.guidance-container {
    height: 100%;
    overflow-y: auto;
    div {
        margin-top: -2px;
    }
}
</style>
